import { useEffect, useMemo, useState } from "react";

import { GetVariables } from "../../../services/api/Listagens/GetVariables";
import { VerifyAPI } from "../../../services/api/Listagens/VerifyAPI";
import { ApiInsert } from "../../../services/api/Listagens/ApiInsert";

import { notify } from "../../../shared/utils/utils";
import {
  buildVariablesByCategory,
  flattenVariables,
  normalize,
} from "../utils/sheetsAdd.utils";

export default function useApiRestAddController({
  setAlreadyFetchSheets,
}) {
  const [dataR, setDataR] = useState([]);
  const [variablesOfTemplate, setVariablesOfTemplate] = useState({});
  const [loadingVerify, setLoadingVerify] = useState(false);
  const [loadingAdd, setLoadingAdd] = useState(false);

  const allVariables = useMemo(
    () => flattenVariables(variablesOfTemplate),
    [variablesOfTemplate],
  );

  /* =========================
     Carrega variáveis do sistema
  ========================= */
  useEffect(() => {
    async function fetchVariables() {
      try {
        const resultJson = await GetVariables();
        const grouped = buildVariablesByCategory(resultJson?.data || []);
        setVariablesOfTemplate(grouped);
      } catch (err) {
        console.error(err);
      }
    }

    fetchVariables();
  }, []);

  /* =========================
     STEP 1 - Verifica API
  ========================= */
  async function handleVerifyAPI(formData) {
    try {
      setLoadingVerify(true);

      const payload = {
        ...formData,
      };

      const response = await VerifyAPI(payload);

      // 🔥 Ajuste importante aqui
      const responseData = response?.data || response;

      if (responseData?.status !== "success") {
        notify("Error", "Erro ao consultar API.", true);
        return false;
      }

      const example = responseData?.item_example;

      if (!example || typeof example !== "object") {
        notify("Error", "API não retornou dados válidos.", true);
        return false;
      }

      const items = Object.entries(example)
        .filter(([field]) => field !== "row_number")
        .map(([field, value], index) => {
          const match = allVariables.find(
            (v) => normalize(v) === normalize(field),
          );

          return {
            field,
            value: value ?? "", // 🔥 trata null
            column_index: index,
            variable: match || null,
          };
        });

      if (!items.length) {
        notify("Error", "A API não retornou campos mapeáveis.", true);
        return false;
      }

      setDataR(items);

      return true;
    } catch (err) {
      console.error(err);
      notify("Error", "Erro ao verificar API.", true);
      return false;
    } finally {
      setLoadingVerify(false);
    }
  }
  /* =========================
     Validação antes de salvar
  ========================= */
  function validateBeforeFinish() {
    const emptyCount = dataR.filter((x) => !x.variable).length;

    const hasChannel =
      dataR.some((x) => x.variable === "WhatsApp") ||
      dataR.some((x) => x.variable === "Email");

    if (!hasChannel) {
      notify(
        "Alert",
        "É obrigatório selecionar a coluna de WhatsApp ou Email.",
        true,
      );
      return { valid: false };
    }

    return { valid: true, emptyCount };
  }

  /* =========================
     STEP FINAL - Salvar API
  ========================= */
  async function handleSubmit({ formData, onSuccess }) {
    try {
      setLoadingAdd(true);

      const variables = dataR
        .filter((item) => item?.field && item?.variable)
        .map((item) => ({
          field: item.field,
          variable: item.variable,
        }));

      let bodyToSend;

      if (formData.method === "POST") {
        if (!formData.body || !formData.body.trim()) {
          bodyToSend = "{}";
        } else {
          bodyToSend = formData.body.trim();
        }
      } else {
        bodyToSend = undefined;
      }

      const payload = {
        title: formData.title,
        desc: formData.desc,
        method: formData.method,
        url: formData.url,
        authorization: formData.authorization,
        body: bodyToSend,
        variables
      };

      const response = await ApiInsert(payload);
      const responseData = response?.data || response;

      if (responseData?.status === "success") {
        notify("Success", "API adicionada com sucesso!", true);
        setAlreadyFetchSheets(false);
        onSuccess?.();
      } else {
        notify("Error", "Erro ao salvar API.", true);
      }
    } catch (err) {
      console.error(err);
      notify("Error", "Erro ao enviar dados.", true);
    } finally {
      setLoadingAdd(false);
    }
  }

  return {
    dataR,
    variablesOfTemplate,
    loadingVerify,
    loadingAdd,
    setDataR,
    handleVerifyAPI,
    validateBeforeFinish,
    handleSubmit,
  };
}
